// Any change in logic here should also go into app/src/experiments/index.jsx

import { useContext } from 'react';
import { VariantName, ExperimentName } from '@letsdothis/experiments';

import { saveExperiment } from '@utils/ldtExperimentStorage';

import { ContextName } from '@/appContext/contextName';
import { checkIfPersisted } from '@/experiments/utils';
import AppContext from '@/context';

interface UseExperimentOptions {
  variant?: keyof typeof VariantName;
  persist?: boolean;
}
type UseExperiment = (
  experiment: keyof typeof ExperimentName,
  options?: UseExperimentOptions,
) => boolean;

// Seems persisted state only tracks experiment name and therefore should only apply
// to when variant used.
const useExperiment: UseExperiment = (experiment, options) => {
  const { variant = VariantName.VARIANT, persist = false } = options || {};
  const appContext = useContext(AppContext);
  const experimentState = appContext[ContextName.EXPERIMENTS];

  if (!(experiment in experimentState)) {
    // TODO: Discuss this, IM(ine and @matteo's)HO is an overkill, don't throw
    throw new Error(`Unknown experiment name: ${String(experiment)}`);
  }

  const isVariant = variant === VariantName.VARIANT;
  const isOverridePersisted = isVariant && checkIfPersisted(experiment);
  const experimentActive = experimentState[experiment] === variant;

  if (experimentActive && isVariant && persist && !isOverridePersisted) {
    saveExperiment(experiment);
  }

  return Boolean(experimentActive || isOverridePersisted);
};

export default useExperiment;
